import axios from '@/axios.js';

export default {
  fetchUsers({commit}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  fetchUser(_context, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
  removeRecord({commit}, userId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
};
